import Button from "components/Button/Button"
import InputPhone from "components/Input/InputPhone"
import ModalCustom from "components/ModalCustom"
import FormInputCard from "./FormInputCard"
import { MESSENGER_NOTIFICATION } from "constants/messenger"
import InputDefault from "components/Input/InputDefault"
import { useString } from "helpers/hooks"
import { useChangeLabelStatusInputPasswordAndConfirm } from "../auth.hook"
import { isValidPhone } from "helpers/utils"
import { STATUS_INPUT } from "components/Input/types"
import { encryptionController } from "controllers/EncryptionController"
import {
  getUserMiddleware,
  postUpdateSecurityCodeAndPhoneNumberMiddleware,
} from "../services/api"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { NAME_LOCALSTORAGE } from "constants/localStorage"
interface Props {
  onCloseModal: () => void
  isNew: boolean
}

export const ChangePhoneNumberModal = (props: Props) => {
  const { onCloseModal, isNew } = props
  const phone = useString("")
  const password = useString("")
  const { statusInputPassword, getStatusInputPassword } =
    useChangeLabelStatusInputPasswordAndConfirm()

  const handleChangePhoneNumber = (value) => {
    phone.setValue(value)
  }
  const handleChangeInput = (event) => {
    password.setValue(event.target.value)
    getStatusInputPassword(event.target.value)
  }
  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  const onSave = async () => {
    const { generatePasswordHashed } = encryptionController()

    const request = {
      phoneNumber: phone.value,
      password: await generatePasswordHashed(password.value),
      code: "",
    }
    postUpdateSecurityCodeAndPhoneNumberMiddleware(request)
      .then(() => {
        toast(
          <LabelNotificationPage
            messenger={MESSENGER_NOTIFICATION.CHANGE_PHONE_NUMBER_SUCCESS}
            type="success"
          />
        )
        getUserMiddleware()
        onCloseModal()
        localStorage.removeItem(NAME_LOCALSTORAGE.REMIND_ME_LATER)
      })
      .catch((error) => {
        const message = error.response?.data?.message ?? "Something went wrong!"
        toast(<LabelNotificationPage messenger={message} type="error" />)
      })
  }

  const isValidPhoneNumber = isValidPhone(phone.value)

  const handleDisableButton = () => {
    if (
      isValidPhoneNumber &&
      statusInputPassword.status === STATUS_INPUT.VALID
    ) {
      return false
    }
    return true
  }

  return (
    <ModalCustom
      label={isNew ? "Set up phone number" : "Update phone number"}
      handleChangeButton={() => onCloseModal}
      bodyChildren={
        <div className="flex flex-col pt-[4px]">
          <div className="flex flex-col mb-[16px]">
            <FormInputCard title="Phone number">
              <InputPhone
                value={phone.value}
                setValue={handleChangePhoneNumber}
                onEnterKeyPress={onKeyPress}
              />
              {phone.value ? (
                <div className="flex mt-1">
                  <p
                    className="font-semibold"
                    style={{
                      color: isValidPhoneNumber ? "#56A012" : "#EA4545",
                      fontSize: 10,
                      lineHeight: "14px",
                    }}
                  >
                    {isValidPhoneNumber
                      ? "Valid phone number format!"
                      : "Invalid phone number format!"}
                  </p>
                </div>
              ) : null}
            </FormInputCard>
            <FormInputCard title="Password" required>
              <InputDefault
                type="password"
                isPassword
                value={password.value}
                onChange={handleChangeInput}
                onKeyPress={onKeyPress}
                status={statusInputPassword.status}
                labelStatus={statusInputPassword.label}
              />
            </FormInputCard>
          </div>
          <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between">
            <Button
              widthBtn={"100%"}
              title="Cancel"
              colorBtn="white"
              onClick={onCloseModal}
            />
            <Button
              widthBtn="100%"
              title="Save"
              colorBtn="yellow"
              onClick={onSave}
              disabled={handleDisableButton()}
            />
          </div>
        </div>
      }
    />
  )
}
